import { Button, Card, Typography, makeStyles } from '@material-ui/core';
import React, { useState } from 'react';

import { Renewal } from 'interface/offers';
import imagePreview from 'assets/img/default-image.png';
import RenewalModal from '../../../Shared/RenewalModal';

const useStyles = makeStyles((theme) => ({
  card: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
  contentCard: {
    position: 'relative',
    maxHeight: '500px',
    width: '500px',
    padding: theme.spacing(4),
    display: 'flex',
    [theme.breakpoints.down(780)]: {
      flexDirection: 'column',
      width: 'auto',
    },
  },
  title: {
    maxWidth: '205px',
    fontSize: '20px',
    fontWeight: 700,
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down(780)]: {
      width: '295px',
    },
  },
  price: {
    fontSize: '20px',
    fontWeight: 600,
    color: theme.palette.primary.dark,
  },
  actionButton: {
    marginTop: theme.spacing(4),
  },
  photo: {
    overflow: 'hidden',
    '& img': {
      width: 212,
      height: 145,
      objectFit: 'cover',
    },
    [theme.breakpoints.up(780)]: {
      marginRight: theme.spacing(5),
    },
  },
  contentDescription: {
    [theme.breakpoints.down(780)]: {
      marginTop: theme.spacing(2),
    },
  },
}));

interface IProps {
  renewals: Renewal[];
  renewal: Renewal;
}

const CardRenewal = ({ renewal, renewals }: IProps) => {
  const classes = useStyles({});

  const [openRenewalModal, setOpenRenewalModal] = useState(false);

  const handleClickOpenRenewalModal = () => {
    setOpenRenewalModal(true);
  };

  const getImageWithFallback = (image: string) => {
    if (image) return image;

    return imagePreview;
  };

  const handleCloseRenewalModal = () => {
    setOpenRenewalModal(false);
  };

  renewal.formattedPrice = renewal.price.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

  return (
    <Card variant='outlined' className={classes.card}>
      <article className={classes.contentCard}>
        <section className={classes.photo}>
          <img src={getImageWithFallback(renewal.images.card)} alt='name' />
        </section>
        <section className={classes.contentDescription}>
          <div>
            <Typography className={classes.title} noWrap>
              {renewal.title}
            </Typography>
          </div>
          <div>
            <Typography className={classes.price} noWrap>
              {renewal.formattedPrice}
            </Typography>
          </div>
          <div>
            <Typography noWrap>Validade: {renewal.validity} dias</Typography>
          </div>
          <div className={classes.actionButton}>
            <Button variant='contained' color='primary' onClick={handleClickOpenRenewalModal}>
              Quero renovar!
            </Button>
          </div>
        </section>
      </article>
      <RenewalModal
        renewal={renewal}
        renewals={renewals}
        openRenewalModal={openRenewalModal}
        handleCloseRenewalModal={handleCloseRenewalModal}
      />
    </Card>
  );
};

export default CardRenewal;
